<ng-template #templateRef
             let-rowData
             let-rowIndex="rowIndex"
             let-columns="columns">
  @if (canApplyGrouping && checkHasRowSpan(rowIndex)) {
    <tr class="sc-table-groupable-row"
        [scReorderableRow]="rowIndex"
        [isGroupRow]="true"
        [rowGroupValue]="getGroupId(rowData)">
      @if (tableSettings.selectionMode) {
        <td class="sc-selectable-column">
        </td>
      }

      @for (column of columns; track column.field) {
        @if (column.isGroupable) {
          <td [attr.rowspan]="getRowSpanCount(rowIndex)"
              class="p-resizable-column">
            @if (column.bodyTemplate && !column.settings.hideCellIf?.(rowData)) {
              <ng-container
                            *ngTemplateOutlet="column.bodyTemplate; context: {$implicit: rowData[column.field], rowData: rowData}">
              </ng-container>
            }
          </td>
        } @else {
          <td></td>
        }
      }

      @if (actionsTemplate) {
        <td class="sc-actions-column sc-actions-column-{{tableSettings.actionsCount}}">
        </td>
      }
    </tr>
  }

  <tr [scReorderableRow]="rowIndex"
      [rowGroupValue]="getGroupId(rowData)"
      [scReorderableRowDisabled]="!canReorderRows"
      (dblclick)="tableSettings.doubleClickRedirectUrl ? navigate(tableSettings.doubleClickRedirectUrl(rowData)) : null"
      [ngStyle]="tableSettings.rowStyler ? tableSettings.rowStyler(rowData): null">
    @if (tableSettings.selectionMode) {
      <td class="sc-selectable-column">
        @switch (tableSettings.selectionMode) {
          @case ('single') {
            <p-tableRadioButton [value]="rowData"
                                (dblclick)="preventMouseEvent($event)"></p-tableRadioButton>
          }
          @case ('multiple') {
            <p-tableCheckbox [value]="rowData"
                             (dblclick)="preventMouseEvent($event)"></p-tableCheckbox>
          }
        }
      </td>
    }

    @if (tableSettings.reordering?.separateColumn) {
      <td class="sc-reordering-column">
        <i pReorderableRowHandle
           class="fas fa-up-down"></i>
      </td>
    }

    @for (column of columns; track column.field) {
      @let hasNoGrouping = checkHasNoGrouping(column.isGroupable, rowIndex);
      @let renderable = !column.settings.hideCellIf?.(rowData);
      @if (column.isEditable && hasNoGrouping && renderable) {
        <td class="p-resizable-column"
            #editableColumn="scEditableColumn"
            [scEditableColumn]="rowData"
            [pEditableColumnField]="column.field"
            [pEditableColumnRowIndex]="rowIndex"
            [ngClass]="{ 'sc-td-white-space-normal': column.settings.wrap }"
            [ngStyle]="column.bodyStyle"
            [column]="column">
          <p-cellEditor class="sc-overflow-ellipsis">

            @if (!column.settings.editable.showIcon) {
              <ng-template pTemplate="input">
                <div class="relative">
                  <ng-container
                                *ngTemplateOutlet="column.bodyEditableTemplate; context: {$implicit: rowData[column.field], rowData: rowData, rowIndex: rowIndex }">
                  </ng-container>
                </div>
              </ng-template>
              <ng-template pTemplate="output">
                <ng-container
                              *ngTemplateOutlet="column.bodyTemplate; context: {$implicit: rowData[column.field], rowData: rowData, rowIndex: rowIndex}">
                </ng-container>
              </ng-template>
            }

            @if (column.settings.editable.showIcon) {
              <ng-template pTemplate="input">
                <ng-container
                              *ngTemplateOutlet="column.bodyEditableTemplate; context: {$implicit: rowData[column.field], rowData: rowData, rowIndex: rowIndex }">
                </ng-container>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="flex align-items-center sc-overflow-ellipsis">
                  <i class="fas fa-pen mr-3"></i>

                  <div class="flex-grow-1 relative sc-overflow-ellipsis">
                    <ng-container
                                  *ngTemplateOutlet="column.bodyTemplate; context: {$implicit: rowData[column.field], rowData: rowData, rowIndex: rowIndex}">
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            }
          </p-cellEditor>

          @if (editableColumn.canSwapValues) {
            <p-button [disabled]="editableColumn.swapButtonDisabled"
                      pTooltip="Click to swap values"
                      i18n-pTooltip
                      tooltipPosition="top"
                      styleClass="p-button-rounded"
                      icon="fas fa-exchange-alt">
            </p-button>
          }
        </td>
      } @else if (column.isEditable && hasNoGrouping) {
        <td class="p-resizable-column"
            [ngStyle]="column.bodyStyle"></td>
      } @else if (!column.isEditable && hasNoGrouping) {
        <td class="p-resizable-column"
            [ngClass]="{ 'sc-row-reorder-column': column.isReorderable, 'text-center': column.settings.centered, 'sc-td-white-space-normal': column.settings.wrap }"
            [ngStyle]="column.bodyStyle">
          @if (column.isReorderable) {
            <span pReorderableRowHandle
                  class="p-element"
                  [ngClass]="{ 'fas fa-up-down' : !tableSettings.reordering?.separateColumn }"></span>
          }
          @if (column.bodyTemplate && renderable) {
            <ng-container
                          *ngTemplateOutlet="column.bodyTemplate; context: {$implicit: rowData[column.field], rowData: rowData, rowIndex: rowIndex}">
            </ng-container>
          } @else {
            {{rowData[column.field]}}
          }
        </td>
      }
    }

    @if (actionsTemplate) {
      <td class="sc-actions-column sc-actions-column-{{tableSettings.actionsCount}}">
        <ng-container *ngTemplateOutlet="actionsTemplate; context: {$implicit: rowData, rowIndex: rowIndex}">
        </ng-container>
      </td>
    }
  </tr>
</ng-template>